export default __webpack_public_path__ + "783faa331c37eb56207ac0e88040c6d1.png";